import {
  blackColor,
  grayColor,
  hexToRgb,
  whiteColor
} from "assets/jss/style.js";

const footerPanelStyle = {
  root: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    fontWeight: "300",
    lineHeight: "1.5em",
    position: "fixed",
    right: "0",
    width: "100%",
    background: "rgba(0, 0, 0, 0.3)",
    zIndex: "1031",
    textAlign: "center",
    bottom: "0px"
  },
  rootDivBoton: {
    "& > *": {
      margin: "1px"
    }
  },

  rootBoton: {
    color: "#022635 !important",
    "&:hover,&:focus": {
      color: whiteColor,
      backgroundColor: "#0127386b",
      boxShadow:
        "0 14px 26px -12px rgba(" +
        hexToRgb(grayColor[0]) +
        ", 0.42), 0 4px 23px 0px rgba(" +
        hexToRgb(blackColor) +
        ", 0.12), 0 8px 10px -5px rgba(" +
        hexToRgb(grayColor[0]) +
        ", 0.2)"
    }
  },
  text: {
    padding: "2px"
  },
  paper: {
    paddingBottom: "5px"
  },
  list: {
    marginBottom: "2px"
  },
  appBar: {
    top: "auto !important",
    bottom: 0,
    minHeight: "40px !important",
    display: "block",
    background: "rgba(0, 0, 0, 0.2) !important"
  },
  grow: {
    flexGrow: 1
  },
  fabButton: {
    position: "absolute",
    zIndex: 1,
    top: -30,
    left: 0,
    right: 0,
    margin: "0 auto"
  },
  inputTrans: {
    width: "48px",
    height: "18px",
    fontSize: "12px",
    padding: "2px",
    marginRight: "10px",
    border: "1px solid #022635",
    borderRadius: "3px",
    fontWeight: "700",
    textAlign: "center"
  }
};

export default footerPanelStyle;
